// Rails' unobtrusive JavaScript: links with data-method (e.g. link_to ..., method: :delete) and data-confirm. Starting it
// after jQuery is global also makes it add the CSRF token to jQuery's Ajax requests.
import Rails from '@rails/ujs'

Rails.start()
